import React, { useCallback, useContext } from 'react';
import EDMenuButton from '../../../../BaseComponents/Buttons/MenuButton/EDMenuButton';
import MenuButtonItem from '../../../../BaseComponents/Buttons/MenuButton/EDMenuButtonItem';
import { ActiveDatabaseContext } from '../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { ActiveRoutineContext } from '../../../Routing/ActiveRoutine/ActiveRoutineContext';
import { BusinessCollectionMenuItem } from '../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/Components/BusinessCollectionMenuItem';
import {
  ICustomAddButtonProps,
  IRenderButtonProps,
} from '../../_Common/Const/Delsystem';
import {
  hasRutinKod,
  isReadOnlyRutin,
} from '../ObjektVyer/Aktivitet/Utils/AktivitetUtils';
import { ViewDbSettingsContext } from './Kalender/Components/SchedulerComponent/ViewDbSettingsContext';

export const AktivitetTypUnderMeny: React.FC<
  React.PropsWithChildren<ICustomAddButtonProps>
> = props => {
  const { setNewObject, renderButton } = props;
  const databaseContext = useContext(ActiveDatabaseContext);
  const availableRoutines = databaseContext.availableRoutines;
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const activeRoutineContext = useContext(ActiveRoutineContext);

  const onClick1 = useCallback(() => {
    viewDbSettingsContext.setCalendarSelection(undefined);
    setNewObject?.('GUDSTJANST');
  }, [setNewObject, viewDbSettingsContext]);
  const onClick2 = useCallback(() => {
    viewDbSettingsContext.setCalendarSelection(undefined);
    setNewObject?.('AKTOVRIGT');
  }, [setNewObject, viewDbSettingsContext]);

  const renderMenuTrigger = useCallback(
    ({ onClick, disabled, icon, label }: IRenderButtonProps) =>
      renderButton?.({
        onClick,
        disabled,
        title: disabled ? 'Välj minst en bokningsbar resurs' : undefined,
        icon,
        label,
      }) as React.ReactElement,
    [renderButton]
  );

  if (
    !hasRutinKod('rtnWebKalender', availableRoutines) ||
    isReadOnlyRutin('rtnWebKalender', availableRoutines)
  ) {
    return null;
  }

  const hasOnlyAktovrigtPermission =
    !hasRutinKod('rtnWebBokaGudstjanst', availableRoutines) ||
    isReadOnlyRutin('rtnWebBokaGudstjanst', availableRoutines);

  const disabled =
    activeRoutineContext?.rutinInfo.rutinKod === 'rtnWebKalender' &&
    !viewDbSettingsContext?.resources?.find(res => res.kanBoka) &&
    !viewDbSettingsContext.loggedInUserResource?.kanBoka;

  const disabledReason = 'Välj minst en bokningsbar resurs';

  if (hasOnlyAktovrigtPermission) {
    if (renderButton) {
      return renderButton({
        onClick: () => onClick2(),
        disabled,
        title: disabled ? disabledReason : undefined,
        icon: 'add',
        label: 'Skapa ny',
      }) as React.ReactElement;
    }
    return (
      <BusinessCollectionMenuItem
        icon="add"
        tooltip="Skapa ny"
        expanded={props.expanded}
        testId={props.testId}
        onClick={onClick2}
        disabled={disabled}
        disabledReason={disabledReason}
      />
    );
  }

  if (renderButton) {
    return (
      <EDMenuButton
        icon="add"
        iconSize="default"
        tooltip="Skapa ny"
        margin="none"
        padding="normal"
        disabled={disabled}
        disabledReason={disabledReason}
        testId={props.testId}
        renderButton={renderMenuTrigger}
      >
        {hasRutinKod('rtnWebBokaGudstjanst', availableRoutines) &&
          !isReadOnlyRutin('rtnWebBokaGudstjanst', availableRoutines) &&
          hasRutinKod('rtnWebKalender', availableRoutines) && (
            <MenuButtonItem onClick={onClick1}>Gudstjänst</MenuButtonItem>
          )}
        {hasRutinKod('rtnWebKalender', availableRoutines) && (
          <MenuButtonItem onClick={onClick2}>Övrig aktivitet</MenuButtonItem>
        )}
      </EDMenuButton>
    );
  }

  return (
    <BusinessCollectionMenuItem
      icon="add"
      tooltip="Skapa ny"
      expanded={props.expanded}
      testId={props.testId}
      disabled={disabled}
      disabledReason={disabledReason}
    >
      {hasRutinKod('rtnWebBokaGudstjanst', availableRoutines) &&
        !isReadOnlyRutin('rtnWebBokaGudstjanst', availableRoutines) &&
        hasRutinKod('rtnWebKalender', availableRoutines) && (
          <MenuButtonItem onClick={onClick1}>Gudstjänst</MenuButtonItem>
        )}
      {hasRutinKod('rtnWebKalender', availableRoutines) && (
        <MenuButtonItem onClick={onClick2}>Övrig aktivitet</MenuButtonItem>
      )}
    </BusinessCollectionMenuItem>
  );
};
